import FontFaceObserver from "fontfaceobserver"
import ScrollManager from "./ScrollManager"
import LazyLoad from "./LazyLoad"
import Gallery from "./home/our-hotels-gallery"
import InclusionHovers from "./home/inclusion-hovers"
import Loader from "./Loader";

// Nimbus Sans Regular, Benton Sans Compressed Bold/Medium, Moret Regular
window.addEventListener('load', () => {
  const Nimbus = new FontFaceObserver('nimbus-sans');
  const Benton = new FontFaceObserver('benton-sans-compressed');
  const Moret = new FontFaceObserver('moret')
  new LazyLoad()

  const scrollManager = new ScrollManager()

  scrollManager.pause = true

  const loader = new Loader({
    cb: () => {
      scrollManager.resize()
      scrollManager.pause = false
    }
  })

  Promise.all([Nimbus.load(), Benton.load(), Moret.load()]).then(function () {
    loader.play()

    // HOME Sections (For scroll triggered sections look in ScrollManager.js)
    new Gallery()
    new InclusionHovers()

  });
})